import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface Certification {
  name: string;
  issuer: string;
  icon: string;
  region: string;
}

interface CertificationBadgesProps {
  certifications: Certification[];
  className?: string;
}

const CertificationBadges = ({
  certifications,
  className = '',
}: CertificationBadgesProps) => {
  return (
    <section className={`bg-surface py-16 md:py-20 ${className}`}>
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center space-x-2 bg-trust/10 px-4 py-2 rounded-full mb-4">
            <Icon name="ShieldCheckIcon" size={20} className="text-trust" />
            <span className="text-trust font-medium text-sm">
              Certified & Verified
            </span>
          </div>
          <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary mb-4">
            Industry Certifications & Accreditations
          </h2>
          <p className="text-text-secondary max-w-2xl mx-auto">
            Our services meet the highest international standards and regional compliance requirements
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {certifications.map((cert, index) => (
            <div
              key={index}
              className="bg-card rounded-xl p-6 border border-border hover:border-trust hover:shadow-natural transition-all duration-300"
            >
              <div className="flex items-center justify-center w-16 h-16 bg-trust/10 rounded-xl mb-4 mx-auto">
                <Icon
                  name={cert.icon as any}
                  size={32}
                  className="text-trust"
                  variant="solid"
                />
              </div>
              <h3 className="font-heading font-bold text-lg text-text-primary text-center mb-2">
                {cert.name}
              </h3>
              <p className="text-text-secondary text-sm text-center mb-2">
                {cert.issuer}
              </p>
              <div className="inline-flex items-center justify-center w-full">
                <span className="text-xs bg-trust/10 text-trust px-3 py-1 rounded-full font-medium">
                  {cert.region}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CertificationBadges;